import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

import CoreUtils from '../../common/utils/CoreUtils';
import DomUtils from '../../common/utils/DomUtils';
import ReactUtils from '../../common/utils/ReactUtils';

import { Tooltip } from 'devextreme-react/tooltip';

import EnergyCellEditor from './EnergyCellEditor.js';
import './EnergyCellPopOutEditor.css';

export default class EnergyCellPopOutEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.tooltipRef = React.createRef();
    this.editorRef = React.createRef();

    this.popOutEditorId = 'EnergyCellPopOutEditor_' + crypto.randomUUID();

    this.scheduleId = null;
    this.dataField = null;
    this.isEditorShown = false;
    this.focusOnLastValue = false;

    this.editorPosition = {
      my: 'center top',
      at: 'center bottom'
    };
  }

  dispose() {
    var tooltip = this.resolveTooltip();
    if (CoreUtils.isDefinedAndNotNull(tooltip))
      tooltip.dispose();
  }

  render() {
    return (
      <Tooltip
        animation={null}
        closeOnOutsideClick={true}
        contentRender={this.renderPlaceholder.bind(this)}
        deferRendering={false}
        hideOnParentScroll={true}
        onHidden={this.onToolTipHidden.bind(this)}
        onHiding={this.onToolTipHiding.bind(this)}
        onShowing={this.onToolTipShowing.bind(this)}
        onShown={this.onToolTipShown.bind(this)}
        ref={this.tooltipRef}
        wrapperAttr={{ class: 'pwx-popout-energy-cell-editor' }}
      />
    );
  }

  renderPlaceholder() {
    return (<div id={this.popOutEditorId} />);
  }

  renderContent(previousResolution) {
    return (
      <EnergyCellEditor
        commandDataModel={this.props.commandDataModel}
        dataModel={this.props.dataModel}
        scheduleId={this.scheduleId}
        dataField={this.dataField}
        previousResolution={previousResolution}
        onCloseEditor={this.closeEditor.bind(this)}
        onFocusBackward={this.onFocusBackward.bind(this)}
        onFocusForward={this.onFocusForward.bind(this)}
        onResize={this.repositionEditor.bind(this)}
        ref={this.editorRef}
      />
    );
  }

  resolveTooltip() {
    return ReactUtils.resolveReference(this.tooltipRef);
  }

  resolveEditor() {
    return this.editorRef.current;
  }

  onToolTipHidden() {
    var editor = this.resolveEditor();
    if (CoreUtils.isDefinedAndNotNull(editor))
      editor.onEditorHidden();

    this.scheduleId = null;
    this.dataField = null;
  }

  onToolTipHiding() {
    var editor = this.resolveEditor();
    if (CoreUtils.isDefinedAndNotNull(editor))
      editor.onEditorHiding();

    this.isEditorShown = false;
  }

  onToolTipShowing() {
    var editor = this.resolveEditor();
    if (CoreUtils.isDefinedAndNotNull(editor))
      editor.onEditorShowing();
  }

  onToolTipShown() {
    this.isEditorShown = true;

    var editor = this.resolveEditor();
    if (CoreUtils.isDefinedAndNotNull(editor)) {
      editor.onEditorShown();
      editor.onEditorFocus(this.focusOnLastValue);
    }

    this.focusOnLastValue = false;
  }

  onFocusBackward(scheduleId, dataField, currentResolution) {
    var tooltip = this.resolveTooltip();
    if (CoreUtils.isUndefinedOrNull(tooltip))
      return;

    tooltip.hide().then(() => {
      if (CoreUtils.isDefinedAndNotNull(this.props.onFocusBackward))
        this.props.onFocusBackward(scheduleId, dataField, currentResolution);
    });
  }

  onFocusForward(scheduleId, dataField, currentResolution) {
    var tooltip = this.resolveTooltip();
    if (CoreUtils.isUndefinedOrNull(tooltip))
      return;

    tooltip.hide().then(() => {
      if (CoreUtils.isDefinedAndNotNull(this.props.onFocusForward))
        this.props.onFocusForward(scheduleId, dataField, currentResolution);
    });
  }

  showEditor(scheduleId, dataField, previousResolution, focusOnLastValue) {
    var tooltip = this.resolveTooltip();
    if (CoreUtils.isUndefinedOrNull(tooltip))
      return;

    this.scheduleId = scheduleId;
    this.dataField = dataField;
    this.focusOnLastValue = focusOnLastValue;

    if (this.isEditorShown) {
      var editor = this.resolveEditor();
      if (CoreUtils.isDefinedAndNotNull(editor)) {
        if (scheduleId === editor.props.scheduleId && dataField === editor.props.dataField) {
          editor.onEditorFocus(this.focusOnLastValue);
          this.focusOnLastValue = false;
          return;
        }
      }

      tooltip.hide()
        .then(() => this.beginShowingEditor(tooltip, previousResolution));
    }
    else
      this.beginShowingEditor(tooltip, previousResolution);
  }

  beginShowingEditor(tooltip, previousResolution) {
    var container = document.getElementById(this.popOutEditorId);
    ReactDOM.render(this.renderContent(previousResolution), container);

    var pivotElements = CoreUtils.isDefinedAndNotNull(this.props.onResolvePivotElements)
      ? this.props.onResolvePivotElements(this.scheduleId, this.dataField)
      : {};

    tooltip.option('position', this.editorPosition);
    tooltip.show(pivotElements.cellElement);
  }

  repositionEditor() {
    if (!this.isEditorShown)
      return;

    var tooltip = this.resolveTooltip();
    if (CoreUtils.isUndefinedOrNull(tooltip)
      || CoreUtils.isUndefinedOrNull(this.props.onResolvePivotElements))
      return;

    var pivotElements = this.props.onResolvePivotElements(this.scheduleId, this.dataField);

    if (DomUtils.isElementScrolledIntoView(pivotElements.cellElement, pivotElements.scrollableParentElement)) {
      tooltip.option('position', this.editorPosition);
      tooltip.show(pivotElements.cellElement);
    } else {
      tooltip.hide();
    }
  }

  closeEditor() {
    if (!this.isEditorShown)
      return;

    var tooltip = this.resolveTooltip();
    if (CoreUtils.isDefinedAndNotNull(tooltip))
      tooltip.hide();
  }
}